// =========================================================================================@@
// Last Updated Date: Dec 7, 2022
// Last Updated By: Ajay
// Status Level: 3
// ===========================================================================================

import { useMutation } from '@apollo/client'
import { createDiscount as createDiscountGql }
   from 'src/core/graphql/mutations/createDiscount.gql'

const useCreateDiscount = (mutationHookOptions) => {
   const [createDiscount, { called, client, data, error, loading }] =
      useMutation(createDiscountGql, mutationHookOptions)

   const wrappedMutationFn = (input, mutationFnOptions) => createDiscount({
      variables: { input },
      ...mutationFnOptions
   })

   return {
      createDiscount: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreateDiscount
